import CatalogSelectField from './catalog-select-field';
import InfiniteFetcher from '../infinite-fetcher';

export default {
  props: {
    value: null,
    itemHint: {
      type: String,
    },
    searchParam: {
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      searchItems: [],
      initialItems: [],
      search: null,
      lazy: true,
      loading: false,
      delayed: null,
    };
  },
  computed: {
    valueExists() {
      if (Array.isArray(this.value)) {
        return !!this.value.length;
      }

      return !!this.value;
    },
    items() {
      return [...this.initialItems, ...this.searchItems];
    },
  },
  watch: {
    search() {
      if (this.lazy) {
        return;
      }

      clearTimeout(this.delayed);

      this.resetSearchItems();

      this.delayed = setTimeout(() => this.fetchSearchItems(), 500);
    },
    value() {
      this.setInitialItems();
    },
  },
  created() {
    this.setInitialItems();
  },
  methods: {
    setInitialItems() {
      if (!this.valueExists) {
        this.initialItems = [];

        return;
      }

      this.fetchInitialItems().catch(() => {});
    },
    handleFocus() {
      if (!this.lazy || this.loading) {
        return;
      }

      this.lazy = false;

      this.fetchSearchItems();
    },
    async fetchItems(params = {}) {
      const keys = Object.keys(params);

      throw new Error(`fetchItems(${keys}) is not defined in parent component`);
    },
    fetchInitialItems() {
      let { value } = this;

      if (!value || !this.itemValue) {
        return;
      }

      if (Array.isArray(value)) {
        if (!value.length) {
          return;
        }

        value = [...value];
      }

      this.loading = true;

      return this.fetchItems({ [this.itemValue]: value })
        .then(({ data }) => {
          const { result: initialItems } = data;

          this.initialItems = initialItems;
        })
        .catch(() => {
          this.$toast.error(`${this.label}: не удалось загрузить список`);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchSearchItems() {
      const { next: page } = this.pagination;

      const params = {
        [this.searchParam || this.itemText]: this.search,
        page,
      };

      this.loading = true;

      return this.fetchItems(params)
        .then(({ data }) => {
          const {
            pagination: { current_page: current, next_page: next },
            result: searchItems,
          } = data;

          this.searchItems.push(...searchItems);

          this.updatePagination(current, next);

          return Promise.resolve(data);
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    handleChange() {
      this.search = null;
    },
    resetSearchItems() {
      this.searchItems = [];

      this.resetPagination();
    },
    infiniteFetcher() {
      return this.fetchSearchItems();
    },
  },
  mixins: [CatalogSelectField, InfiniteFetcher],
};
